import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import { MainRating } from '../mainRating/MainRating'
import { LevelTip } from './levelTip/LevelTip'
import './RanksTip.css'

interface RanksTipProps {
	rank: number;
	level: number;
	name: string;
	pointsToNext: number;
	allRanks: { rank: number; name: string; points: number, isHighlited: boolean }[];
}

export const RanksTip = ({ rank, level, name, pointsToNext, allRanks }: RanksTipProps) => {
	const language = useStore(state => state.language) as keyof typeof translations;
	const t = translations[language];

	return (
		<div className='ranks-tip'>
			<div className='ranks-tip-header'>
				<div className='ranks-tip-header-icon' style={{scale: 0.5}}>
					<MainRating withoutUnderlying rating={rank} level={level} />
				</div>
				<div className='ranks-tip-header-info'>
					<div className='rank-tip-header-title'>
						<p>{t.rating} “{name}”</p>
					</div>

					<div className='rank-tip-header-description'>
						<div className='ranks-tip-header-level'>
							<p>{t.level}: <span className='bold'>{level}</span></p>
						</div>

						<div className='ranks-tip-header-next'>
							<p>{t.points_to_next_level}: <span className='bold'>{pointsToNext}</span></p>
						</div>
					</div>
				</div>
			</div>

			<div className='ranks-tip-body'>
				
				<div className='ranks-tip-body-header'>
						<p style={{textTransform: 'capitalize'}}>{t.level}</p>
						<p>{t.points_amount}</p>
				</div>

				<div className='ranks-tip-levels'>
					{allRanks.map((rank) => (
						<LevelTip 
							key={rank.rank}
							level={rank.rank}
							name={rank.name}
							text={rank.points}
							isHighlited={rank.isHighlited}
						/>
					))}
				</div>
			</div>
		</div>
	)
}